import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ImageUploadService {
  constructor(private http: HttpClient) {}

  public async uploadImage(orgId: string, file: File, uploadUrl: string): Promise<string> {
    const formData = new FormData();
    formData.append('file', file);

    try {
      const url = uploadUrl.replace(':orgId', orgId);
      const result = await firstValueFrom(this.http.post<any>(url, formData));
      return result.proxyUrl;
    } catch (error) {
      console.error('Image upload failed:', error);
      throw error;
    }
  }
}
